import { ref as g, computed as p, readonly as Ve, toValue as E, watch as N, useSSRContext as Qe, onMounted as $, onErrorCaptured as We, getCurrentInstance as De, onUnmounted as Ye, getCurrentScope as Ze, onScopeDispose as Ke, shallowRef as le, onBeforeMount as Xe, onBeforeUnmount as Je } from "vue";
import { initializeStore as de, SeamlessConnection as et } from "@seamless/store";
import { subscribe as tt } from "@seamless/one-context";
import { initializeLogger as fe } from "@seamless/logger";
import { getTranslation as Q } from "@owc/aem-translations-util";
import { MediaQueryService as Oe } from "@workbench/core";
import { u as tr } from "./useUuid-BHJNgR58.js";
var w = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "Mercedes-Benz", e.MERCEDES_AMG = "Mercedes-AMG", e.MERCEDES_MAYBACH = "Mercedes-Maybach", e))(w || {}), R = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "MERCEDES_BENZ", e.MERCEDES_AMG = "MERCEDES_AMG", e.MERCEDES_MAYBACH = "MERCEDES_MAYBACH", e.MERCEDESBENZ = "Mercedes-Benz", e.MERCEDESAMG = "Mercedes-AMG", e.MERCEDESMAYBACH = "Mercedes-Maybach", e))(R || {}), ce = /* @__PURE__ */ ((e) => (e.AMG = "amg", e.MAYBACH = "maybach", e))(ce || {}), W;
// @__NO_SIDE_EFFECTS__
function nt(e) {
  return {
    lang: e?.lang ?? W?.lang,
    message: e?.message,
    abortEarly: e?.abortEarly ?? W?.abortEarly,
    abortPipeEarly: e?.abortPipeEarly ?? W?.abortPipeEarly
  };
}
var rt;
// @__NO_SIDE_EFFECTS__
function at(e) {
  return rt?.get(e);
}
var ot;
// @__NO_SIDE_EFFECTS__
function st(e) {
  return ot?.get(e);
}
var it;
// @__NO_SIDE_EFFECTS__
function ct(e, t) {
  return it?.get(e)?.get(t);
}
// @__NO_SIDE_EFFECTS__
function Ie(e) {
  const t = typeof e;
  return t === "string" ? `"${e}"` : t === "number" || t === "bigint" || t === "boolean" ? `${e}` : t === "object" || t === "function" ? (e && Object.getPrototypeOf(e)?.constructor?.name) ?? "null" : t;
}
function M(e, t, n, r, o) {
  const c = o && "input" in o ? o.input : n.value, a = o?.expected ?? e.expects ?? null, i = o?.received ?? /* @__PURE__ */ Ie(c), s = {
    kind: e.kind,
    type: e.type,
    input: c,
    expected: a,
    received: i,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${i}`,
    requirement: e.requirement,
    path: o?.path,
    issues: o?.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, u = e.kind === "schema", l = o?.message ?? e.message ?? /* @__PURE__ */ ct(e.reference, s.lang) ?? (u ? /* @__PURE__ */ st(s.lang) : null) ?? r.message ?? /* @__PURE__ */ at(s.lang);
  l !== void 0 && (s.message = typeof l == "function" ? (
    // @ts-expect-error
    l(s)
  ) : l), u && (n.typed = !1), n.issues ? n.issues.push(s) : n.issues = [s];
}
// @__NO_SIDE_EFFECTS__
function L(e) {
  return {
    version: 1,
    vendor: "valibot",
    validate(t) {
      return e["~run"]({ value: t }, /* @__PURE__ */ nt());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ut(e, t) {
  const n = [...new Set(e)];
  return n.length > 1 ? `(${n.join(` ${t} `)})` : n[0] ?? "never";
}
// @__NO_SIDE_EFFECTS__
function F(e, t) {
  return {
    kind: "validation",
    type: "max_length",
    reference: F,
    async: !1,
    expects: `<=${e}`,
    requirement: e,
    message: t,
    "~run"(n, r) {
      return n.typed && n.value.length > this.requirement && M(this, "length", n, r, {
        received: `${n.value.length}`
      }), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function q(e, t) {
  return {
    kind: "validation",
    type: "min_length",
    reference: q,
    async: !1,
    expects: `>=${e}`,
    requirement: e,
    message: t,
    "~run"(n, r) {
      return n.typed && n.value.length < this.requirement && M(this, "length", n, r, {
        received: `${n.value.length}`
      }), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function pe(e, t) {
  return {
    kind: "validation",
    type: "regex",
    reference: pe,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    "~run"(n, r) {
      return n.typed && !this.requirement.test(n.value) && M(this, "format", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ne(e, t, n) {
  return typeof e.fallback == "function" ? (
    // @ts-expect-error
    e.fallback(t, n)
  ) : (
    // @ts-expect-error
    e.fallback
  );
}
// @__NO_SIDE_EFFECTS__
function lt(e, t) {
  return {
    ...e,
    fallback: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      const o = e["~run"](n, r);
      return o.issues ? { typed: !0, value: /* @__PURE__ */ Ne(this, o, r) } : o;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Pe(e, t, n) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, n)
  ) : (
    // @ts-expect-error
    e.default
  );
}
// @__NO_SIDE_EFFECTS__
function me(e, t) {
  return {
    kind: "schema",
    type: "array",
    reference: me,
    expects: "Array",
    async: !1,
    item: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      const o = n.value;
      if (Array.isArray(o)) {
        n.typed = !0, n.value = [];
        for (let c = 0; c < o.length; c++) {
          const a = o[c], i = this.item["~run"]({ value: a }, r);
          if (i.issues) {
            const s = {
              type: "array",
              origin: "value",
              input: o,
              key: c,
              value: a
            };
            for (const u of i.issues)
              u.path ? u.path.unshift(s) : u.path = [s], n.issues?.push(u);
            if (n.issues || (n.issues = i.issues), r.abortEarly) {
              n.typed = !1;
              break;
            }
          }
          i.typed || (n.typed = !1), n.value.push(i.value);
        }
      } else
        M(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function D(e, t) {
  return {
    kind: "schema",
    type: "literal",
    reference: D,
    expects: /* @__PURE__ */ Ie(e),
    async: !1,
    literal: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      return n.value === this.literal ? n.typed = !0 : M(this, "type", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Be(e, t) {
  return {
    kind: "schema",
    type: "nullish",
    reference: Be,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    default: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      return (n.value === null || n.value === void 0) && (this.default !== void 0 && (n.value = /* @__PURE__ */ Pe(this, n, r)), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function j(e, t) {
  return {
    kind: "schema",
    type: "object",
    reference: j,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      const o = n.value;
      if (o && typeof o == "object") {
        n.typed = !0, n.value = {};
        for (const c in this.entries) {
          const a = this.entries[c];
          if (c in o || (a.type === "exact_optional" || a.type === "optional" || a.type === "nullish") && // @ts-expect-error
          a.default !== void 0) {
            const i = c in o ? (
              // @ts-expect-error
              o[c]
            ) : /* @__PURE__ */ Pe(a), s = a["~run"]({ value: i }, r);
            if (s.issues) {
              const u = {
                type: "object",
                origin: "value",
                input: o,
                key: c,
                value: i
              };
              for (const l of s.issues)
                l.path ? l.path.unshift(u) : l.path = [u], n.issues?.push(l);
              if (n.issues || (n.issues = s.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            s.typed || (n.typed = !1), n.value[c] = s.value;
          } else if (a.fallback !== void 0)
            n.value[c] = /* @__PURE__ */ Ne(a);
          else if (a.type !== "exact_optional" && a.type !== "optional" && a.type !== "nullish" && (M(this, "key", n, r, {
            input: void 0,
            expected: `"${c}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: o,
                key: c,
                // @ts-expect-error
                value: o[c]
              }
            ]
          }), r.abortEarly))
            break;
        }
      } else
        M(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function V(e) {
  return {
    kind: "schema",
    type: "string",
    reference: V,
    expects: "string",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, n) {
      return typeof t.value == "string" ? t.typed = !0 : M(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Se(e) {
  let t;
  if (e)
    for (const n of e)
      t ? t.push(...n.issues) : t = n.issues;
  return t;
}
// @__NO_SIDE_EFFECTS__
function $e(e, t) {
  return {
    kind: "schema",
    type: "union",
    reference: $e,
    expects: /* @__PURE__ */ ut(
      e.map((n) => n.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      let o, c, a;
      for (const i of this.options) {
        const s = i["~run"]({ value: n.value }, r);
        if (s.typed)
          if (s.issues)
            c ? c.push(s) : c = [s];
          else {
            o = s;
            break;
          }
        else
          a ? a.push(s) : a = [s];
      }
      if (o)
        return o;
      if (c) {
        if (c.length === 1)
          return c[0];
        M(this, "type", n, r, {
          issues: /* @__PURE__ */ Se(c)
        }), n.typed = !0;
      } else {
        if (a?.length === 1)
          return a[0];
        M(this, "type", n, r, {
          issues: /* @__PURE__ */ Se(a)
        });
      }
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ee(...e) {
  return {
    ...e[0],
    pipe: e,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, n) {
      for (const r of e)
        if (r.kind !== "metadata") {
          if (t.issues && (r.kind === "schema" || r.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !n.abortEarly && !n.abortPipeEarly) && (t = r["~run"](t, n));
        }
      return t;
    }
  };
}
const Ge = /^[a-zA-Z]{2}$/, dt = /* @__PURE__ */ Ee(
  /* @__PURE__ */ V(),
  /* @__PURE__ */ q(2),
  /* @__PURE__ */ F(2),
  /* @__PURE__ */ pe(Ge, "Must match two-letter pattern")
), ft = /* @__PURE__ */ Ee(
  /* @__PURE__ */ V(),
  /* @__PURE__ */ q(2),
  /* @__PURE__ */ F(2),
  /* @__PURE__ */ pe(Ge, "Must match two-letter pattern")
), pt = /* @__PURE__ */ Be(/* @__PURE__ */ Ee(/* @__PURE__ */ V(), /* @__PURE__ */ q(3), /* @__PURE__ */ F(5))), xe = /* @__PURE__ */ lt(
  /* @__PURE__ */ $e([
    /* @__PURE__ */ D("MERCEDES_BENZ"),
    /* @__PURE__ */ D("MERCEDES_AMG"),
    /* @__PURE__ */ D("MERCEDES_MAYBACH"),
    /* @__PURE__ */ D("Mercedes-Benz"),
    /* @__PURE__ */ D("Mercedes-AMG"),
    /* @__PURE__ */ D("Mercedes-Maybach")
  ]),
  "Mercedes-Benz"
), mt = /* @__PURE__ */ j({
  lang: dt,
  market: ft,
  stage: pt,
  brand: /* @__PURE__ */ me(xe)
});
({
  ...mt.entries,
  ...(/* @__PURE__ */ j({ brand: /* @__PURE__ */ me(xe) })).entries
});
function He(e, t, n) {
  return !t || !n ? null : `${t}${e[1]}${n}`;
}
const Y = g(null), I = g({}), Et = p(() => {
  var e, t;
  return He`${(e = I.value) == null ? void 0 : e.language}-${(t = I.value) == null ? void 0 : t.country}`;
}), gt = p(() => {
  var e, t;
  return He`${(e = I.value) == null ? void 0 : e.language}_${(t = I.value) == null ? void 0 : t.country}`;
}), vt = ({ options: e }) => {
  tt("PageConnection", { tenant: "sccs", componentName: "vus-connection", callback: (r) => {
    t(r.pageEnvironmentVariables);
  } });
  function t(r) {
    var o, c;
    (c = (o = e.logger) == null ? void 0 : o.debug) == null || c.call(o, "assigning state: ", r), Object.assign(I.value, r);
  }
  function n() {
    var r;
    (r = Y.value) == null || r.call(Y), Y.value = null;
  }
  return { owcAemEnv: Ve(I), marketIdDashed: Et, marketIdUnderscored: gt, close: n };
}, St = ({ options: e }) => {
  const t = de(), { owcAemEnv: n, marketIdDashed: r, marketIdUnderscored: o, close: c } = vt({ subscription: t.once, options: e });
  return { close: c, owcAemEnv: n, marketIdDashed: r, marketIdUnderscored: o };
}, be = fe("DH_IO_SCSS/ENVIRONMENT"), ge = new URLSearchParams(window.location.search), he = ge.get("echoTargetEnv")?.toLowerCase(), ye = ge.get("fe-one-teaser-platform_config_useCurrentEnv"), bt = ye && ["f", "false"].includes(ye.toLowerCase()), Ce = ge.get("fe-vehicle-tiles_Config_USE_CURRENT_ENV"), ht = Ce && ["f", "false"].includes(Ce.toLowerCase());
function yt(e) {
  switch (e?.toLowerCase()?.trim() ?? "prod") {
    case "dev":
    case "development":
    case "local":
    case "localhost":
    case "test":
    case "testing":
      return "TEST";
    case "int":
    case "integration":
      return "INT";
    case "pprod":
    case "preprod":
    case "pre-production":
    case "preproduction":
      return "PPROD";
    case "prod":
    case "production":
      return "PROD";
    default:
      return "PROD";
  }
}
function Ue() {
  const { close: e, owcAemEnv: t, marketIdDashed: n, marketIdUnderscored: r } = St({ options: { logger: be } }), o = p(() => {
    const u = bt || ht ? "prod" : void 0, l = t.value?.stage, d = yt(he ?? u ?? l);
    return be?.log(`stage set to ${d}`, { urlParamEchoTargetEnv: he, urlParamUseCurrentEnv: u, aemEnv: l }), d;
  }), c = p(() => t.value?.country), a = p(() => t.value?.language), i = p(() => t.value?.vehicleData?.subBrands[0]), s = p(() => t.value?.brand?.subBrand);
  return {
    close: e,
    environment: o,
    country: c,
    language: a,
    marketIdDashed: n,
    marketIdUnderscored: r,
    subBrandFromVehicleDataState: i,
    subBrandFromEnvironmentState: s
  };
}
function Ct(e) {
  switch (e) {
    case w.MERCEDES_AMG:
    case R.MERCEDES_AMG:
    case R.MERCEDESAMG:
    case ce.AMG:
      return w.MERCEDES_AMG;
    case w.MERCEDES_MAYBACH:
    case R.MERCEDES_MAYBACH:
    case R.MERCEDESMAYBACH:
    case ce.MAYBACH:
      return w.MERCEDES_MAYBACH;
    default:
      return w.MERCEDES_BENZ;
  }
}
const { subBrandFromVehicleDataState: At, subBrandFromEnvironmentState: Mt } = Ue();
function Rn(e) {
  const t = p(() => {
    const r = E(e) ?? Mt.value ?? At.value;
    return Ct(r);
  }), n = p(() => {
    switch (t?.value) {
      case w.MERCEDES_AMG:
        return R.MERCEDESAMG;
      case w.MERCEDES_MAYBACH:
        return R.MERCEDESMAYBACH;
      default:
        return R.MERCEDESBENZ;
    }
  });
  return { subBrand: t, brandUrlParameter: n };
}
function Tt(e) {
  return e.toLowerCase().trim();
}
const Ln = "fe-vehicle-tiles", Z = "fe-one-teaser-platform", _t = {
  LOCAL: "https://assets.oneweb.mercedes-benz.com",
  TEST: "https://dev.assets.oneweb.mercedes-benz.com",
  INT: "https://int.assets.oneweb.mercedes-benz.com",
  PPROD: "https://preprod.assets.oneweb.mercedes-benz.com",
  PROD: "https://assets.oneweb.mercedes-benz.com"
};
function wt(e, t, n) {
  const o = _t[e === "PROD" ? "PROD" : "PPROD"], c = Tt(t);
  return `${o}/config/emh/${n}/${c}/config.json`;
}
const A = fe("DH_IO_SCSS/CONFIG_SERVICE_OT");
async function Rt(e) {
  const t = new Request(e);
  try {
    return await fetch(t);
  } catch (n) {
    return A.warn("Error fetching config from network", n), Response.error();
  }
}
let K = null;
function kn(e) {
  const t = g(null), n = g(!0), r = g(null), o = new URLSearchParams(window.location.search), c = (f, S, y, C) => {
    const T = Z + "_" + f + "_" + S, k = o.get(T), G = k ? ["t", "true"].includes(k.toLowerCase()) : void 0, O = G ?? y ?? C;
    return A.log(Z + "_" + f + "_" + S + " set to " + O, {
      urlParamResult: G,
      configServiceResult: y,
      fallback: C
    }), O;
  }, a = p(() => !n.value), i = p(
    () => c("focMarket", "isFocMarket", t.value?.focMarket?.isFocMarket, !1)
  ), s = p(
    () => c(
      "personalization",
      "personalizationEnabled",
      t.value?.personalization?.personalizationEnabled,
      !1
    )
  ), u = p(
    () => c(
      "switchToOneTeaser",
      "enableOneTeaserHome",
      t.value?.switchToOneTeaser?.enableOneTeaserHome,
      !0
    )
  ), l = p(
    () => c(
      "switchToOneTeaser",
      "enableOneTeaserCampaign",
      t.value?.switchToOneTeaser?.enableOneTeaserCampaign,
      !0
    )
  ), d = p(
    () => c("config", "failOnMissingPrice", t.value?.config?.failOnMissingPrice, !0)
  );
  async function v() {
    n.value = !0, r.value = null, b().then((f) => {
      if (f) {
        if (f.error)
          throw A.warn("fetching configs failed", f.error), f.error;
        t.value = f.body, n.value = !1, A.log("configs set", t.value, e.stage, e.country);
      }
    });
  }
  async function b() {
    return t.value ? (A.log("configs already loaded"), { body: t.value, error: null }) : (K ? A.log("configs already loaded by another component, using that response") : (A.log("fetching configs"), K = new Promise((f) => {
      (async () => {
        try {
          const S = E(e.stage), y = E(e.country);
          if (!S || !y) {
            f(null), A.log("stage or country missing", S, y);
            return;
          }
          const C = wt(S, y, Z), T = await Rt(C);
          if (!T?.ok) {
            f({
              body: null,
              error: new Error(`HTTP error, failed to load config! status: ${T?.status}`)
            });
            return;
          }
          const k = await T.json();
          A.log("configs fetched", k), f({ body: k, error: null });
        } catch (S) {
          A.warn("unknown error occured", S), f({ body: null, error: new Error("Unknown error occurred") });
        }
      })();
    })), K);
  }
  return N(
    [e.stage, e.country],
    ([f, S]) => {
      !f || !S || v();
    },
    {
      immediate: !0
    }
  ), {
    isFeatureToggleLoaded: a,
    isFocMarket: i,
    isPersonalizationEnabled: s,
    isOneTeaserHomeEnabled: u,
    isOneTeaserCampaignEnabled: l,
    isFailOnMissingPriceEnabled: d
  };
}
/*! aem-component-data-util 1.2.0 */
function Lt(e) {
  if (!(typeof window < "u")) {
    let o = Qe()?.AEMContext;
    return { payload: o?.payload, config: o?.config };
  }
  let n = window.top || window, r = n.__GLOBAL_CONTEXT__?.get()?.componentData ?? n.aemNamespace?.componentData;
  return e ? Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, r[o]])) : r[e] : r;
}
const Dn = (e, t = {
  reactive: !0
}) => {
  const n = g([]), r = g(null);
  function o(c) {
    const a = c.querySelector("[data-slot-outlet]");
    if (!a || !a.children.length) return;
    const i = a.children[0].localName === "slot" ? a.children[0].assignedElements() : a.children, s = Array.from(i || []).map(
      (u) => u?.getAttribute("component-id")
    );
    n.value = [];
    for (const u of s) {
      if (!u) continue;
      const l = { payload: Lt(u).payload, componentId: u };
      n.value.push(l);
    }
  }
  return $(() => {
    const c = E(e);
    if (!c || (o(c), !t.reactive)) return;
    r.value?.disconnect();
    const a = { childList: !0, subtree: !0 }, i = (u) => {
      u.some((d) => d.type === "childList") && o(c);
    };
    r.value = new MutationObserver(i);
    const s = c?.querySelector("[data-slot-outlet]");
    s && r.value.observe(s, a);
  }), { childElementConfigs: n, syncConfigs: o };
}, X = {
  separator: "-",
  id: "35e68f8b5769ffbe51d5e3e245f7498f"
}, J = {
  separator: "-",
  id: "256327257efa0b223e1fa85ba6b0cbf7"
}, ee = {
  separator: "_",
  id: "42b5f1b854ae37cc8b351c232bf6cb79"
}, kt = "SCCS_MBTI-DISCO-AIR", On = ["Mercedes-AMG", "MERCEDES_AMG"], In = Symbol.for("componentId"), Nn = "Mercedes-Benz";
function Pn(e, t, n = de()) {
  const r = g();
  let o;
  const { unsubscribe: c } = n.subscribe(kt, (s) => {
    o = s, i(E(e), E(t));
  });
  function a(s) {
    return r.value?.tileData && r.value?.state === "SUCCESS" && r.value?.inflateId === s;
  }
  function i(s, u) {
    if (s) {
      if (u) {
        r.value = {
          tileData: { ...u, state: "SUCCESS" },
          state: "SUCCESS",
          inflateId: s
        };
        return;
      }
      if (!a(s)) {
        if (!o || s && !o?.tileData?.[s])
          r.value = {
            // waiting for connection
            state: "PENDING",
            inflateId: s ?? "no-inflate-id-could-be-determined"
          };
        else if (s) {
          const l = o?.tileData?.[s], d = l?.state;
          r.value = {
            tileData: l,
            state: d,
            inflateId: s
          };
        }
      }
    }
  }
  return N(
    [() => E(e), () => E(t)],
    ([s, u]) => {
      i(s, u);
    },
    { immediate: !0 }
  ), { tileDataBundle: r, unsubscribe: c };
}
const te = fe("DH_IO_SCSS/I18N");
let ne = null;
const x = g({}), H = g({}), re = g({}), { marketIdUnderscored: Dt, marketIdDashed: Ot } = Ue();
function Bn() {
  const e = async (a) => {
    let i = a === "-" ? await Ot.value : await Dt.value;
    return i === `de${a}AQ` && (i = `de${a}DE`), i === `en${a}AQ` && (i = `en${a}AU`), i ?? "xx-XX";
  };
  async function t() {
    return ne ? te.log("translations already loaded by another component, using that response") : (te.log("fetching translations"), ne = new Promise((a) => {
      (async () => {
        try {
          x.value = await Q(
            await e(ee.separator),
            ee.id,
            "i18next"
          );
        } catch (i) {
          console.warn(
            `CMN_I18N_CMP: Failed to fetch compare translations for market ${await e(ee.separator)}`,
            { cause: i }
          );
        }
        try {
          H.value = await Q(
            await e(X.separator),
            X.id,
            "i18next"
          );
        } catch (i) {
          console.warn(
            `CMN_I18N_DCP: Failed to fetch DCP translations for market ${await e(X.separator)}`,
            { cause: i }
          );
        }
        try {
          re.value = await Q(
            await e(J.separator),
            J.id,
            "i18next"
          );
        } catch (i) {
          console.warn(
            `CMN_I18N_OT: Failed to fetch OneTeaser translations for market ${await e(J.separator)}`,
            { cause: i }
          );
        }
        te.log("translations loaded", {
          compareTranslations: x.value,
          dcpTranslations: H.value,
          oneTeaserTranslations: re.value
        }), a();
      })();
    })), ne;
  }
  function n(a) {
    return !!o(a, x.value) || !!o(a, H.value);
  }
  function r(a, i) {
    if (!a)
      return "";
    const s = o(a, x.value) || o(a, H.value) || o(a, re.value) || a;
    return c(s, i);
  }
  function o(a, i) {
    const s = a.split(".");
    let u = i;
    for (const l of s) {
      if (u === void 0 || typeof u == "string") return;
      u = u[l];
    }
    if (typeof u == "string")
      return u;
  }
  function c(a, i) {
    if (!i)
      return a;
    let s = a;
    return Object.entries(i).forEach((u) => {
      const [l, d] = u;
      s = s.replace(`{{${l}}}`, d), s = s.replace(`{{ ${l} }}`, d), s = s.replace(`{${l}}`, d), s = s.replace(`{ ${l} }`, d);
    }), s;
  }
  return { loadTranslations: t, t: r, existsWithoutFallback: n };
}
function $n(e) {
  const t = p(() => E(e) === "campaign"), n = p(() => E(e) === "overlapping"), r = p(() => E(e) === "workbench7"), o = p(() => E(e) === "compact"), c = p(() => E(t) || n.value || r.value ? "classic" : "compact"), a = p(() => E(c) === "classic");
  return {
    isAppearanceCampaign: t,
    isAppearanceOverlapping: n,
    isAppearanceWorkbench: r,
    isAppearanceCompact: o,
    cssProject: c,
    useWbClasses: a
  };
}
function Ae(e) {
  throw Error(e);
}
var It = /* @__PURE__ */ ((e) => (e[e.COMPONENT = 1] = "COMPONENT", e[e.DATALOADING = 2] = "DATALOADING", e[e.IMAGE = 3] = "IMAGE", e[e.PLS = 4] = "PLS", e[e.FCIS = 5] = "FCIS", e))(It || {}), Nt = /* @__PURE__ */ ((e) => (e.CRITICAL = "CRITICAL", e.HIGH = "HIGH", e.MEDIUM = "MEDIUM", e.LOW = "LOW", e))(Nt || {});
function Pt({ error: e, severity: t, component: n, message: r }, o) {
  switch (t) {
    case "CRITICAL":
    case "HIGH":
      o?.error("An error has been encountered, please find more information below"), o?.table({
        severity: t,
        category: n,
        message: r,
        cause: e?.cause
      });
      break;
    case "MEDIUM":
    case "LOW":
    default:
      o?.log(`Error in component ${n} with severity ${t}: ${r}`, e);
      break;
  }
}
const Gn = (e) => {
  const t = g(/* @__PURE__ */ new Map());
  We((a, i, s) => {
    const u = i, l = u._.type.__name === "ErrorBoundary" ? De() ?? Ae("could not find vue instance") : u._, d = l.exposed?.severity ?? "CRITICAL", v = l.exposed?.category ?? 1, b = { error: a, severity: d, component: v, message: a.message };
    if (n(l, b), Pt(b, e.logger), e.onErrorCallback?.(), !e.allowPropagation) return !1;
  }), $(() => {
    r();
  }), Ye(() => {
    r();
  });
  function n(a, { error: i, severity: s, component: u }) {
    const l = a.type.name ?? a.type.__name ?? Ae("a component catching errors must have a name");
    if (t.value.has(l)) {
      const d = t.value.get(l);
      if (!d) return;
      t.value.set(l, [
        ...d,
        { error: i, severity: s, component: u, message: i?.message ?? "" }
      ]);
    } else
      t.value.set(l, [
        { error: i, severity: s, component: u, message: i?.message ?? "" }
      ]);
  }
  function r() {
    t.value.clear();
  }
  const o = p(() => !!t.value.size), c = p(() => Array.from(t.value.values()).reduce((a, i) => a + i.length, 0));
  return { componentsWithErrors: t, hasErrors: o, errorCount: c };
};
function xn(e = window) {
  return {
    currentStaticMediaQuery: new Oe(e).getCurrentMediaQuery()
  };
}
function Hn(e, t, n, r) {
  const o = (a) => {
    n(), a?.disconnect(), r?.logger?.debug(`fired load event for ${e} and query ${t}`);
  };
  function c(a) {
    if (a.shadowRoot) {
      const i = (u, l) => {
        if (!a.shadowRoot) throw new Error("element does not have a shadowRoot");
        const d = a.shadowRoot.querySelector(t);
        d && "complete" in d && d.complete ? o(l) : d && d.addEventListener("load", () => {
          o(l);
        });
      };
      new MutationObserver(i).observe(a.shadowRoot, { subtree: !0, childList: !0 });
    }
  }
  N(
    e,
    (a) => {
      a && customElements.whenDefined(a.localName).then(() => c(E(a)));
    },
    { immediate: !0 }
  );
}
/*! connection-aem-tracking 2.8.0 */
const je = "OWC_TRACKING_MANAGER", Me = "PUSH_TRACKING_EVENT", Te = { trackingEvents: [] };
new class extends et {
  constructor() {
    super(je);
  }
  get initialState() {
    return Te;
  }
  getReducer() {
    return (e = Te, t) => t.type === this.getActionType(Me) ? { ...e, trackingEvents: [...e.trackingEvents, t.payload] } : e;
  }
  getPublicDispatchers() {
    return { pushTrackingEvent: (e) => (window.top?.dataLayer_ow.push(e), this.getAction(Me, e)) };
  }
}();
const Bt = () => de().getConnectionDispatchers(je).then(((e) => e));
function $t(e) {
  return Ze() ? (Ke(e), !0) : !1;
}
const Gt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const xt = (e) => e != null, ae = () => {
};
function Ht(e) {
  return Array.isArray(e) ? e : [e];
}
function Ut(e, t, n) {
  return N(
    e,
    t,
    {
      ...n,
      once: !0
    }
  );
}
const ze = Gt ? window : void 0;
function oe(e) {
  var t;
  const n = E(e);
  return (t = n?.$el) != null ? t : n;
}
// @__NO_SIDE_EFFECTS__
function jt() {
  const e = le(!1), t = De();
  return t && $(() => {
    e.value = !0;
  }, t), e;
}
// @__NO_SIDE_EFFECTS__
function zt(e) {
  const t = /* @__PURE__ */ jt();
  return p(() => (t.value, !!e()));
}
function Ft(e, t, n = {}) {
  const {
    root: r,
    rootMargin: o = "0px",
    threshold: c = 0,
    window: a = ze,
    immediate: i = !0
  } = n, s = /* @__PURE__ */ zt(() => a && "IntersectionObserver" in a), u = p(() => {
    const f = E(e);
    return Ht(f).map(oe).filter(xt);
  });
  let l = ae;
  const d = le(i), v = s.value ? N(
    () => [u.value, oe(r), d.value],
    ([f, S]) => {
      if (l(), !d.value || !f.length)
        return;
      const y = new IntersectionObserver(
        t,
        {
          root: oe(S),
          rootMargin: o,
          threshold: c
        }
      );
      f.forEach((C) => C && y.observe(C)), l = () => {
        y.disconnect(), l = ae;
      };
    },
    { immediate: i, flush: "post" }
  ) : ae, b = () => {
    l(), v(), d.value = !1;
  };
  return $t(b), {
    isSupported: s,
    isActive: d,
    pause() {
      l(), d.value = !1;
    },
    resume() {
      d.value = !0;
    },
    stop: b
  };
}
function qt(e, t = {}) {
  const {
    window: n = ze,
    scrollTarget: r,
    threshold: o = 0,
    rootMargin: c,
    once: a = !1
  } = t, i = le(!1), { stop: s } = Ft(
    e,
    (u) => {
      let l = i.value, d = 0;
      for (const v of u)
        v.time >= d && (d = v.time, l = v.isIntersecting);
      i.value = l, a && Ut(i, () => {
        s();
      });
    },
    {
      root: r,
      window: n,
      threshold: o,
      rootMargin: E(c)
    }
  );
  return i;
}
var Vt = /* @__PURE__ */ ((e) => (e.CAMPAIGN = "campaign", e.SLEEK = "sleek", e.YOUNGSTARS = "young_stars", e.RICH = "rich", e))(Vt || {});
const _e = {
  eventName: "view_promotion",
  category: "impression",
  label: void 0
  // no label for impression regarding documentation
}, Un = {
  eventName: "select_promotion",
  category: "link",
  label: "teaser"
  /* TEASER */
}, jn = {
  eventName: "select_promotion",
  category: "link"
  /* LINK */
};
function zn(e, t, n) {
  let r = null;
  Xe(async () => {
    r ||= await Bt();
  });
  function o(a, i, s) {
    const u = g(!1), l = qt(a), d = s ?? g(void 0), v = N(
      [l, d],
      ([b, f]) => {
        b && !u.value && f && (u.value = !0, i ? c(_e, i, f) : c(_e, void 0, f), v?.());
      },
      { immediate: !0 }
    );
  }
  async function c(a, i, s) {
    const l = n?.connections?.keys().find((v) => v?.toLowerCase().startsWith("emh")), d = {
      event: "click",
      eventDetail: {
        name: a.eventName,
        category: a.category,
        action: `banner.${e}`,
        label: a.label,
        URL: a.URL ?? void 0,
        promotion: i
      },
      application: {
        id: l ? "emh" : "seamless_emh",
        version: "",
        subId: "vehicles",
        type: s,
        parentApplicationId: "aem",
        businessUnit: t?.value?.toLowerCase() ?? void 0
      }
    };
    typeof requestIdleCallback == "function" ? requestIdleCallback(() => {
      r?.pushTrackingEvent(d);
    }) : r?.pushTrackingEvent(d);
  }
  return {
    track: c,
    trackVisibility: o
  };
}
var Qt = typeof global == "object" && global && global.Object === Object && global, Wt = typeof self == "object" && self && self.Object === Object && self, Fe = Qt || Wt || Function("return this")(), z = Fe.Symbol, qe = Object.prototype, Yt = qe.hasOwnProperty, Zt = qe.toString, B = z ? z.toStringTag : void 0;
function Kt(e) {
  var t = Yt.call(e, B), n = e[B];
  try {
    e[B] = void 0;
    var r = !0;
  } catch {
  }
  var o = Zt.call(e);
  return r && (t ? e[B] = n : delete e[B]), o;
}
var Xt = Object.prototype, Jt = Xt.toString;
function en(e) {
  return Jt.call(e);
}
var tn = "[object Null]", nn = "[object Undefined]", we = z ? z.toStringTag : void 0;
function rn(e) {
  return e == null ? e === void 0 ? nn : tn : we && we in Object(e) ? Kt(e) : en(e);
}
function an(e) {
  return e != null && typeof e == "object";
}
var on = "[object Symbol]";
function sn(e) {
  return typeof e == "symbol" || an(e) && rn(e) == on;
}
var cn = /\s/;
function un(e) {
  for (var t = e.length; t-- && cn.test(e.charAt(t)); )
    ;
  return t;
}
var ln = /^\s+/;
function dn(e) {
  return e && e.slice(0, un(e) + 1).replace(ln, "");
}
function ue(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Re = NaN, fn = /^[-+]0x[0-9a-f]+$/i, pn = /^0b[01]+$/i, mn = /^0o[0-7]+$/i, En = parseInt;
function Le(e) {
  if (typeof e == "number")
    return e;
  if (sn(e))
    return Re;
  if (ue(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ue(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = dn(e);
  var n = pn.test(e);
  return n || mn.test(e) ? En(e.slice(2), n ? 2 : 8) : fn.test(e) ? Re : +e;
}
var se = function() {
  return Fe.Date.now();
}, gn = "Expected a function", vn = Math.max, Sn = Math.min;
function bn(e, t, n) {
  var r, o, c, a, i, s, u = 0, l = !1, d = !1, v = !0;
  if (typeof e != "function")
    throw new TypeError(gn);
  t = Le(t) || 0, ue(n) && (l = !!n.leading, d = "maxWait" in n, c = d ? vn(Le(n.maxWait) || 0, t) : c, v = "trailing" in n ? !!n.trailing : v);
  function b(m) {
    var _ = r, P = o;
    return r = o = void 0, u = m, a = e.apply(P, _), a;
  }
  function f(m) {
    return u = m, i = setTimeout(C, t), l ? b(m) : a;
  }
  function S(m) {
    var _ = m - s, P = m - u, ve = t - _;
    return d ? Sn(ve, c - P) : ve;
  }
  function y(m) {
    var _ = m - s, P = m - u;
    return s === void 0 || _ >= t || _ < 0 || d && P >= c;
  }
  function C() {
    var m = se();
    if (y(m))
      return T(m);
    i = setTimeout(C, S(m));
  }
  function T(m) {
    return i = void 0, v && r ? b(m) : (r = o = void 0, a);
  }
  function k() {
    i !== void 0 && clearTimeout(i), u = 0, r = s = o = i = void 0;
  }
  function G() {
    return i === void 0 ? a : T(se());
  }
  function O() {
    var m = se(), _ = y(m);
    if (r = arguments, o = this, s = m, _) {
      if (i === void 0)
        return f(s);
      if (d)
        return clearTimeout(i), i = setTimeout(C, t), b(s);
    }
    return i === void 0 && (i = setTimeout(C, t)), a;
  }
  return O.cancel = k, O.flush = G, O;
}
let U;
const hn = () => U = new Oe(window), ke = (e, t = 300) => {
  const n = bn(e, t);
  $(() => {
    h.addResizeEventListener(n);
  }), Je(() => {
    h.removeResizeEventListener(n);
  });
}, h = {
  /**
   * Gets the current breakpoint.
   * @returns {string} - Current breakpoint.
   */
  getCurrentBreakpoint() {
    return U?.getCurrentMediaQuery().toLowerCase() || "mq1";
  },
  /**
   * Adds a resize event listener.
   * @param {Function} callback - Callback function for resize events.
   */
  addResizeEventListener(e) {
    window.addEventListener("wbresize", e), U.observe(!0);
  },
  /**
   * Removes a resize event listener.
   * @param {Function} callback - Callback function to remove.
   */
  removeResizeEventListener(e) {
    window.removeEventListener("wbresize", e), U.disconnect();
  },
  /**
   * Checks if the viewport is mobile.
   * @returns {boolean} - True if mobile, false otherwise.
   */
  isMobile() {
    return ["mq1", "mq2", "mq3"].includes(h.getCurrentBreakpoint());
  },
  /**
   * Checks if the viewport is tablet.
   * @returns {boolean} - True if tablet, false otherwise.
   */
  isTablet() {
    return ["mq1", "mq2", "mq3", "mq4"].includes(h.getCurrentBreakpoint());
  },
  /**
   * Checks if the viewport is desktop.
   * @returns {boolean} - True if desktop, false otherwise.
   */
  isDesktop() {
    return ["mq5", "mq6"].includes(h.getCurrentBreakpoint());
  }
}, Fn = () => {
  const e = g(h.getCurrentBreakpoint()), t = g(h.isMobile()), n = g(h.isTablet()), r = g(h.isDesktop());
  return $(async () => {
    hn();
  }), ke(() => {
    n.value = h.isTablet(), t.value = h.isMobile(), r.value = h.isDesktop(), e.value = h.getCurrentBreakpoint();
  }), {
    breakpoint: e,
    isTablet: n,
    isMobile: t,
    isDesktop: r,
    onWindowResize: ke
  };
}, ie = {
  MERCEDES_BENZ: {
    LEFT: ["A_CLASS", "B_CLASS", "CLA_CLASS", "GLA_CLASS", "GLB_CLASS", "EQA_CLASS", "EQB_CLASS", "EQT_CLASS"],
    CENTER: ["C_CLASS", "GLC_CLASS", "E_CLASS", "CLE_CLASS", "V_CLASS", "EQV_CLASS"],
    // temp solution: Removing EQE_CLASS, long term adjustments in inflate
    RIGHT: ["GLE_CLASS", "EQE_CLASS", "EQS_CLASS", "GLS_CLASS", "G_CLASS", "S_CLASS"]
  },
  MERCEDES_AMG: {
    LEFT: ["A_CLASS", "CLA_CLASS"],
    CENTER: ["C_CLASS", "GLC_CLASS", "E_CLASS", "EQE_CLASS"],
    RIGHT: ["GLE_CLASS", "EQE_CLASS", "EQS_CLASS", "GLS_CLASS", "G_CLASS", "S_CLASS", "SL_CLASS", "GT_CLASS"]
  },
  MERCEDES_MAYBACH: {
    LEFT: ["GLS_CLASS"],
    CENTER: ["S_CLASS"],
    RIGHT: ["EQS_CLASS"]
  },
  get "Mercedes-Benz"() {
    return ie.MERCEDES_BENZ;
  },
  get "Mercedes-AMG"() {
    return ie.MERCEDES_AMG;
  },
  get "Mercedes-Maybach"() {
    return ie.MERCEDES_MAYBACH;
  }
}, qn = [
  "TR",
  "TH",
  "KR",
  "AU",
  "JP",
  "SG",
  "MY",
  "ZA",
  // 'ZS' in the fincalc list
  "NZ",
  "IN",
  "MX",
  "TW",
  "VN",
  "BR",
  "EG"
], Vn = {
  LEFT: ["SPRINTER"],
  CENTER: ["VITO", "CITAN"],
  RIGHT: ["eCITAN", "eSPRINTER", "eVITO"]
};
function Qn(e) {
  return Object.keys(e).filter((t) => e[t]).join(",");
}
function Wn(e) {
  return Array.isArray(e) ? e.join(",") : "";
}
const Yn = (e, t, n) => e.map((r, o) => yn(r, t[o], o, n)), yn = (e, t, n, r) => ({
  id: void 0,
  name: t?.toLowerCase()?.replace(/ /g, "_") ?? "",
  creative: e.split("/").pop()?.split("?")?.[0] ?? "",
  position: `banner_${r}.${n}`
}), Zn = (e, t) => {
  e.ctrlKey || e.metaKey ? window.open(t, "_blank") : window.location.assign(t);
}, Kn = (e) => ["B2B", "B2C"].includes(e);
function* Xn(...e) {
  const t = e.map((n) => n[Symbol.iterator]());
  for (; ; ) {
    const n = t.map((r) => r.next());
    if (n.some(({ done: r }) => r)) break;
    yield n.map(({ value: r }) => r);
  }
}
export {
  Un as BannerClickEvent,
  Vt as BannerType,
  In as COMPONENT_ID_SYMBOL,
  It as ComponentCategory,
  jn as CtaClickEvent,
  On as DARK_MODE_SUBBRANDS,
  Nn as DEFAULT_BRAND,
  Z as ONE_TEASER,
  qn as OVERSEAS_MARKETS,
  ee as PHRASE_COMPARE,
  X as PHRASE_DCP,
  J as PHRASE_ONE_TEASER,
  Nt as Severity,
  Ln as VEHICLE_TILE,
  Wn as arrayToJoinedString,
  ie as brandToModelMap,
  wt as buildConfigServiceUrl,
  yn as convertBannerItemToTrackingItem,
  Yn as convertBannerItemsToTrackingItems,
  Ct as convertBrandToOurs,
  _e as impressionEvent,
  Kn as isContextType,
  Pt as logError,
  kt as mbtiDiscoAirConnectionName,
  Qn as objectToJoinedString,
  Vn as positionDefinesModel,
  Ae as raise,
  Zn as urlLinkout,
  Ue as useAemEnvironmentConnection,
  $n as useAppearance,
  zn as useBannerTracking,
  Rn as useBrand,
  kn as useConfigService,
  Dn as useDummyConfig,
  Gn as useErrorCapturer,
  Bn as useI18n,
  xn as useMediaQuery,
  Hn as useSubscribeToLoadEventInShadowRoot,
  tr as useUuid,
  Pn as useVehicleTileData,
  Fn as useViewport,
  Xn as zip
};
//# sourceMappingURL=index.js.map
